import { Path, Svg } from '@react-pdf/renderer'

export const ResolutionIcon = () => (
  <Svg height={14} viewBox='0 0 53 53' width={14}>
    <Path
      d='M50.5084 24.1322V26.3555C50.5054 31.5668 48.8179 36.6376 45.6976 40.8116C42.5773 44.9855 38.1913 48.039 33.1938 49.5166C28.1963 50.9942 22.8551 50.8167 17.9667 49.0107C13.0783 47.2047 8.90463 43.8669 6.0682 39.4951C3.23178 35.1232 1.88454 29.9516 2.22743 24.7516C2.57032 19.5515 4.58497 14.6016 7.97089 10.6401C11.3568 6.67855 15.9326 3.91766 21.0158 2.76917C26.0991 1.62069 31.4174 2.14613 36.1776 4.26715M50.5084 7.02215L26.3417 31.213L19.0917 23.963'
      fill='none'
      stroke='#000000'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={4.35}
    />
  </Svg>
)
